
import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
    REQUESTED,
    SUCCESSFUL,
    FAILED,
    RESET_PASSWORD_SUCCESSFUL,
} from './ForgotPasswordActionTypes';


export const initialState = Map({
  error: false,
  success: false,
  isRequested: false,
  errorMessage: '',
  isLoading: false,
  requestCount: 0,
  resetPasswordsuccess: false,
});

const isLoading = state => (state.requestCount - 1) === 0;


const handlers = {
  [REQUESTED](state) {
    return state.merge({
      isRequested: true,
      error: false,
      errorMessage: '',
      success: false,
      requestCount: state.get('requestCount') + 1,
      isLoading: true,
    });
  },
  [FAILED](state, action) {
    return state.merge({
      error: action.error,
      errorMessage: action.error.message,
      success: false,
      isRequested: false,
      requestCount: state.get('requestCount') - 1,
      isLoading: isLoading(state),
    });
  },
  [SUCCESSFUL](state) {
    return state.merge({
      success: true,
      isRequested: false,
      error: false,
      requestCount: state.get('requestCount') - 1,
      isLoading: isLoading(state),
    });
  },
  [RESET_PASSWORD_SUCCESSFUL](state) {
    return state.merge({
      resetPasswordsuccess: true,
      isLoading: isLoading(state),
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      error: false,
      success: false,
      isRequested: false,
    });
  },
};

export const forgot = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.forgot.get('error');
const getSuccess = state => state.forgot.get('success');
const getIsRequested = state => state.forgot.get('isRequested');
const errorMessage = state => state.forgot.get('errorMessage');
const loading = state => state.forgot.get('isLoading');
const getResetPassword = state => state.forgot.get('resetPasswordsuccess');

export const forgotSelector = createStructuredSelector({
  error: getError,
  success: getSuccess,
  isRequested: getIsRequested,
  errorMessage,
  isLoading: loading,
  resetPasswordsuccess: getResetPassword,
});



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/ForgotPassword.redux.js